var Flowcor = Flowcor || {};

Flowcor.ProductFilter = function() {

  var _select = {
    scope : '.page--product-list-page',
    filter : '.filter-bar__filter',
    activeFilter : 'filter-bar__filter--active',
    filterOptionsGroup : '.filter-opts-bar',
    filterOption : '.filter-opts-bar__opt',
    activeFilterOption : 'filter-opts-bar__opt--active',
    defaultFilterOption : '.filter-opts-bar__opt--default',
    product : '.product-list__product',
    hiddenProduct : 'product-list__product--hide',
    productListContainer : '.product-list-container',
    filterLoader : '.filter-loader'
  }

  var _init = function() {
    // parse URL query string
    _parseUrlQueryString();
    // attach filter click event handler
    $(_select.scope + ' ' + _select.filter).on('click', _handleFilterClick);
    // attach filter option click event handler
    $(_select.scope + ' ' + _select.filterOption).on('click', _handleFilterOptionClick);
  }

  var _parseUrlQueryString = function() {
    // get all possible filter keys
    var filterKeys = [];
    $(_select.filter).each(function() {
      filterKeys.push($(this).data('filter'));
    });
    // check url query string for filters
    var urlParams = new URLSearchParams(window.location.search);
    var i;
    for (i = 0; i < filterKeys.length; i++) {
      if (urlParams.has(filterKeys[i])) {
        var filterKey = filterKeys[i];
        var filterOptionKey = urlParams.get(filterKey);
        var filter = $(_select.scope + ' ' + _select.filter + '[data-filter="' + filterKey + '"]');
        var filterOption =  $(_select.scope + ' ' + _select.filterOption + '[data-filter-val="' + filterOptionKey + '"]');
        if (filter.length && filterOption.length) {
          _activateFilter(filter);
          _activateFilterOption(filterKey, filterOption);
          _applyFilterOption(filterKey, filterOptionKey);
        }
        break;
      }
    }
  }

  var _handleFilterClick = function() {
    var filter = $(this);
    // do nothing if filter is active
    if (_isFilterActive(filter)) {
      return;
    }
    // activate the filter
    _activateFilter(filter);
  }

  var _handleFilterOptionClick = function(e) {
    e.preventDefault();
    $(_select.productListContainer).hide();
    $(_select.filterLoader).slideDown();
    var filterOption = $(this);
    var filterKey = filterOption.parents(_select.filterOptionsGroup).data('filter');
    var filterOptionValue = filterOption.data('filter-val');
    // do nothing if filter is active
    if (_isFilterOptionActive(filterOption)) {
      $(_select.filterLoader).hide();
      $(_select.productListContainer).slideDown();
      return;
    }
    // activate the filter
    _activateFilterOption(filterKey, filterOption);
    // apply the filter
    _applyFilterOption(filterKey, filterOptionValue);
  }

  var _isFilterActive = function(filter) {
    if (filter.hasClass(_select.activeFilter)) {
      return true;
    }
    return false;
  }

  var _isFilterOptionActive = function(filterOption) {
    if (filterOption.hasClass(_select.activeFilterOption)) {
      return true;
    }
    return false;
  }

  var _activateFilter = function(filter) {
    // deactivate all filters & activate selected filter
    $(_select.filter).removeClass(_select.activeFilter);
    filter.addClass(_select.activeFilter);
    // hide visible filter option group and show the correct group
    var filterKey = filter.data('filter');
    $(_select.filterOptionsGroup + ':visible').slideUp(100, function() {
      $(_select.filterOptionsGroup + '[data-filter="' + filterKey + '"]').slideDown();
    });
  }

  var _activateFilterOption = function(filterKey, filterOption) {
    // reset all filters to default
    $(_select.filterOption + '.' + _select.activeFilterOption).removeClass(_select.activeFilterOption);
    $(_select.defaultFilterOption, _select.filterOptionsGroup + '[data-filter!="' + filterKey + '"]').addClass(_select.activeFilterOption);
    // deactivate all filter optins within filter & activate selected filter option
    $(_select.filterOption, _select.filterOptionsGroup + '[data-filter="' + filterKey + '"]').removeClass(_select.activeFilterOption);
    filterOption.addClass(_select.activeFilterOption);
  }

  var _applyFilterOption = function(filterKey, filterOptionValue) {
    // loop all products
    $(_select.scope + ' ' + _select.product).each(function() {
      var product = $(this);
      var productData = product.data('filter-props');
      if (productData.hasOwnProperty(filterKey)) {
        if ((productData[filterKey].indexOf(filterOptionValue) > -1) || filterOptionValue === '*') {
          // product.show();
          product.removeClass(_select.hiddenProduct);
        } else {
          // product.hide();
          product.addClass(_select.hiddenProduct);
        }
      }
    });
    $(_select.filterLoader).hide();
    $(_select.productListContainer).slideDown();
    var baseURL = location.protocol + '//' + location.host + location.pathname;
    var newURL = baseURL;
    if (filterOptionValue !== '*') {
      newURL += '?' + filterKey + '=' + filterOptionValue;
    }
    history.pushState(null, null, newURL);
  }

  /** PUBLIC API **/
  return {
    init : function() {return _init();},
  };

}();

$(function() {
  Flowcor.ProductFilter.init();
});
